
import React, { useEffect, useState } from 'react';
import AOS from 'aos';

import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css"
import Video from "../../images/Content/NinnoTech.mp4"
import img1 from "../../images/Content/imgbanner.avif"
import Logo1 from "../../images/Content/logo.png"
import { TypeAnimation } from 'react-type-animation';
import 'animate.css';


const Logop = () => {
  const [aosComplete, setAosComplete] = useState(false);

  useEffect(() => {
    AOS.init();
    AOS.refresh();

    const aosTimeout = setTimeout(() => {
      setAosComplete(true);
    }, 3000); // Cambia este valor según tu necesidad de retraso

    return () => clearTimeout(aosTimeout);
  }, []);

  return (
    <Container>
      <div className='div-inicio' data-aos="flip-right">
        <img src={img1} className='divbanner' alt="Banner"></img>
        <div className='rombo'></div>
        <div className='rombo1'></div>
      </div>
      {aosComplete && (
        <div className='textbaner'>
          <h4 className='logo1'>NinnoTech.<img src={Logo1} alt="Logo" width="30px" height="30px" /></h4>
          <p className='banerp'>
            <TypeAnimation
              sequence={[
                "Transformando ideas en experiencias digitales.",500,
              ]} 
              style={{ fontSize: '1.5em' }}
            />
          </p>
        </div>
      )}
    </Container>
  )
}

export default Logop